<template>
  <div class="mc-detail-alert__new-media-section">
    <template v-if="loading">
      <b-skeleton width="100%" height="390px" />
      <div class="mt-3 d-flex gap-2">
        <b-skeleton width="100%" height="60px" />
        <b-skeleton width="100%" height="60px" />
        <b-skeleton width="100%" height="60px" />
        <b-skeleton width="100%" height="60px" />
        <b-skeleton width="100%" height="60px" />
        <b-skeleton width="100%" height="60px" />
        <b-skeleton width="100%" height="60px" />
      </div>
    </template>
    <SectionMedia
      v-else
      :dvhData="listNotificationMedia"
      :vehicleIdCam="vehicleIdCam"
      :imeiCam="imeiCam"
      :statusText="statusText"
      :deviceType="getDeviceType(deviceCode) ?? ''"
      :rawAlertId="detailNotification.rawAlertId"
      :rawAlertCreatedOn="detailNotification.createdOn"
      :alert-code="detailNotification.alert.alertCode"
      :checkIsDmsAdas="
        detailNotification.alert.alertCategories.some(({ alertCategoryId }) =>
          isDmsAdas(alertCategoryId)
        )
      "
    />
  </div>
</template>
<script>
import SectionMedia from '@/components/ModalAlertMedia/SectionMedia.vue'
import { Helper } from '@/mixin/helper'
import { GET_VEHICLE_STATUS_TEXT } from '@/services/api/trackvideo/video'
import { mapState } from 'vuex'

export default {
  name: 'DetailNotificationMedia',
  components: { SectionMedia },
  mixins: [Helper],
  data() {
    return {
      loading: false,
      statusText: null,
      deviceCode: null,
    }
  },
  computed: {
    ...mapState('notification', ['detailNotification', 'listNotificationMedia']),
    isSalesDemo() {
      const email = this.$store.state.identity.whoami.email
      const demoStaging =
        email === 'mceasy-demo@vsms.co.id' &&
        (window.location.host === 'vsms2-staging.mceasy.cloud' ||
          window.location.host === 'localhost:3000')
      return (
        (demoStaging || window.location.host === 'demo.mceasy.com') &&
        this.$route.query.isDemo === JSON.stringify(true)
      )
    },
    vehicleIdCam() {
      if (!this.detailNotification) return null
      if (this.detailNotification.vehicle.children?.length) {
        return this.detailNotification.vehicle.children[0]?.id
      }
      return this.detailNotification.vehicleId
    },
    imeiCam() {
      if (!this.detailNotification) return null
      if (this.detailNotification.vehicle.children?.length) {
        return this.detailNotification.vehicle.children[0]?.imei
      }
      return this.detailNotification.vehicle.imei
    },
  },
  async mounted() {
    if (this.isSalesDemo) {
      this.loading = true
      const sensor35 = this.detailNotification.vehicle.sensor.find(
        (sensor) => sensor.sensorCode === 35
      )
      this.statusText = sensor35?.statusText ?? '1,2,3,4'
      this.deviceCode = 6001
      await this.delay(1000)
      this.loading = false
    } else {
      this.getDataTrackvision(this.vehicleIdCam)
    }
  },
  methods: {
    async getDataTrackvision(vehicleId) {
      try {
        this.loading = true

        const response = await this.$apollo.query({
          query: GET_VEHICLE_STATUS_TEXT,
          fetchPolicy: 'no-cache',
          variables: {
            filter: {
              vehicleId: [vehicleId],
            },
          },
        })
        const data = response.data.vehicleVideoTrackers.vehicleVideoTrackers[0]
        this.statusText = data.statusText
        this.deviceCode = data.vehicle.device.deviceCode
      } catch (error) {
        this.$mcToast.error(this.$t('global.somethingWentWrong'))
        console.error(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
